<template>
    <div>
        <el-dialog v-model="dailyAttendanceShow" width="500" :show-close="false" :align-center="true" :close-on-click-modal="false">
            <div class="dialog_content">
                <div class="sign_text">每日签到领好礼</div>
                <div class="btn_sign flex Flexalign Flexjustify">
                    <el-image class="integral_icon" :src="iconPath('integral_icon.png')"></el-image>
                    <div>立即签到</div>
                </div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="30" color="#fff">
                        <circle-close />
                    </el-icon>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "GjkcH5DailyAttendance",
    props: {

    },

    data() {
        return {
            dailyAttendanceShow: false,
        };
    },

    mounted() { },

    methods: {
        closePopup(){
            this.dailyAttendanceShow = false;
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: none;
    border-radius: 10px;
    padding: 0;
    width: 648px;
    height: 648px;
    position: relative;
    background: transparent;
}

:deep(.el-dialog__header) {
    display: none;
}

.dialog_content {
    position: relative;
    z-index: 9;
    background-image: url("/public/static/img/daily_Attendance_bg.png");
    width: 648px;
    height: 648px;
    background-size: cover;
    background-repeat: no-repeat;

    .sign_text {
        font-weight: 500;
        font-size: 22px;
        color: #303030;
        position: absolute;
        top: 300px;
        left: 240px;
    }

    .btn_sign {
        width: 202px;
        height: 52px;
        background: linear-gradient(153deg, #FF8802 0%, #FF5001 100%);
        box-shadow: 0px 6px 8px 0px rgba(255, 80, 1, 0.28);
        border-radius: 26px;
        line-height: 52px;
        text-align: center;
        color: #fff;
        position: absolute;
        top: 370px;
        font-size: 20px;
        left: 223px;

        .integral_icon {
            width: 30px;
            height: 30px;
        }
    }
    .close_icon{
        position: absolute;
        right: 110px;
        top: 160px;
    }
}
</style>